const InfoRectangle = ({ text }) => {
    return (
        <div
            className="text-xl font-poppins text-primary-blue font-extralight text-center bg-primary-gold flex flex-col items-center justify-center"
            style={{ width: "280px", height: "100px" }}
        >
            {text}
        </div>
    );
};

export default InfoRectangle;
